import { Controller } from "@hotwired/stimulus"

// Cascading country → state selects for Super Guia mobile navigation.
export default class extends Controller {
  static targets = [ "country", "state" ]
  static values = {
    states: Object,
    currentSlug: String,
    homeUrl: String
  }

  connect() {
    this.syncCountryFromCurrentState()
    this.refreshStates({ preserveSelection: true })
  }

  countryChanged() {
    const country = this.countryTarget.value

    if (!country) {
      window.Turbo.visit(this.homeUrlValue)
      return
    }

    this.refreshStates({ preserveSelection: false })
  }

  stateChanged() {
    const url = this.stateTarget.value
    if (url) window.Turbo.visit(url)
  }

  syncCountryFromCurrentState() {
    if (!this.currentSlugValue) {
      this.countryTarget.value = ""
      return
    }

    Object.entries(this.statesValue).forEach(([ country, states ]) => {
      if (states.some((state) => state.slug === this.currentSlugValue)) {
        this.countryTarget.value = country
      }
    })
  }

  refreshStates({ preserveSelection }) {
    const country = this.countryTarget.value
    const homeUrl = this.homeUrlValue
    const allLabel = this.stateTarget.dataset.allLabel || "Todos os estados"
    const selectedSlug = preserveSelection ? this.currentSlugValue : null

    this.stateTarget.innerHTML = ""

    const allOption = document.createElement("option")
    allOption.value = homeUrl
    allOption.textContent = allLabel
    if (!selectedSlug) allOption.selected = true
    this.stateTarget.appendChild(allOption)

    if (!country) {
      this.stateTarget.disabled = false
      return
    }

    const states = this.statesValue[country] || []

    states.forEach((state) => {
      const option = document.createElement("option")
      option.value = state.url
      option.textContent = `${state.name} (${state.count})`
      option.dataset.slug = state.slug
      if (selectedSlug && state.slug === selectedSlug) option.selected = true
      this.stateTarget.appendChild(option)
    })

    this.stateTarget.disabled = false
  }
}
